import { render, staticRenderFns } from "./VehiclesListComponent.vue?vue&type=template&id=482c676e&"
import script from "./VehiclesListComponent.vue?vue&type=script&lang=js&"
export * from "./VehiclesListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports